export default __webpack_public_path__ + "static/media/course2.79c89169.webp";